<template>
  <section class="proposal-page__section postcard">
    <div class="pp-container --is-narrow">
      <header class="proposal-page__section-heading">
        <h2 class="proposal-page__section-title">Von uns handgeschrieben Grußkarte</h2>
        <p class="proposal-page__section-description">Hinterlassen Sie eine persönliche Botschaft. Diese schreiben unsere Mitarbeiter handschriftlich auf Ihr gewähltes Grußkartenmotiv (160 Zeichen inkludiert). Schönschrift garantiert!</p>
      </header>
    </div>

    <div class="pp-container">
      <img src="@/assets/images/landing-page/handwrite-seal.svg" class="postcard__seal" alt="Schönschrift garantiert!" data-aos="zoom-out" data-aos-delay="3000">

      <ul class="postcard__deck">
        <li class="postcard__card" data-aos="fade-left" data-aos-delay="600" data-aos-duration="200">
          <div>
            <img
              :src="`${data.postcards[2].image[0].replace('componata.de', 'cdn.componata.de')}?format=${webPFormat('jpeg')}&width=700&quality=80&compression=6`"
            >
          </div>
        </li>
        <li class="postcard__card" data-aos="fade-left" data-aos-delay="500" data-aos-duration="200">
          <div>
            <img
              :src="`${data.postcards[0].image[0].replace('componata.de', 'cdn.componata.de')}?format=${webPFormat('jpeg')}&width=700&quality=80&compression=6`"
            >
          </div>
        </li>
        <li class="postcard__card" data-aos="fade-up">
          <div>
            <img
              alt="Handwritten Message"
              :srcset="`
                ${require('@/assets/images/landing-page/handwriting@2x.png')}?format=${webPFormat('png')}&width=1080&nearlossless=1&quality=80 2x,
                ${require('@/assets/images/landing-page/handwriting@2x.png')}?format=${webPFormat('png')}&width=540&nearlossless=1&quality=80 1x
              `"
              :src="`${require('@/assets/images/landing-page/handwriting@2x.png')}?format=${webPFormat('png')}&width=1080&nearlossless=1&quality=80`"
            >
          </div>
        </li>
        <li class="postcard__card" data-aos="fade-right" data-aos-delay="700" data-aos-duration="200">
          <div>
            <img
              :src="`${data.postcards[1].image[0].replace('componata.de', 'cdn.componata.de')}?format=${webPFormat('jpeg')}&width=700&quality=80&compression=6`"
            >
          </div>
        </li>
        <li class="postcard__card" data-aos="fade-right" data-aos-delay="800" data-aos-duration="200">
          <div>
            <img
              :src="`${data.postcards[3].image[0].replace('componata.de', 'cdn.componata.de')}?format=${webPFormat('jpeg')}&width=700&quality=80&compression=6`"
            >
          </div>
        </li>
      </ul>

      <div class="postcard__cta">
        <p>Mehr als <b>30 Motive </b>verfügbar!</p>
      </div>
    </div>
  </section>
</template>

<script>
import { helperMixin } from '@/mixins/HelperMixin';

export default {
  name: 'Postcard',
  mixins: [helperMixin],
  props: ['data']
};
</script>

<style lang="scss" scoped>
/**
 * Postcard
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc The postcard and its feature's section
 * @since 2020-10-28
**/

$component: 'postcard';

.#{$component} {
  position: relative;
  overflow-x: hidden;
  background: #FFF5F5 url('~@/assets/images/landing-page/bgr-sparks.svg') center bottom no-repeat;
  background-size: cover;
  z-index: 0;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 400px;
    @include linear-gradient(to bottom, #FFF5F5, transparent);
    z-index: -1;
  }

  // Relative container for positioning the seal
  .pp-container:nth-child(2) {
    position: relative;
  }

  &__seal {
    position: absolute;
    top: -100px;
    right: -50px;
    width: 150px;
    height: auto;
  }

  // Deck
  &__deck {
    @include unlist;

    display: flex;
    justify-content: center;
    // Add more padding bottom to balance the height of this element regarding the negative translate of some cards
    @include padding-bottom(map-get($spacers, 6));
    @include margin-top(map-get($spacers, 5) * 5);
    margin-left: auto;
    margin-right: auto;
  }

  &__card {
    position: relative;
    flex: 0 0 310px;
    height: auto;
    z-index: 0;

    > div {
      background-color: $white;
      box-shadow: 5px 5px 22px 1px rgba(0, 0, 0, 0.06);
    }

    img {
      max-width: 100%;
      @include imageRendering;
    }

    & + & {
      // outline: 1px solid blue;
      margin-left: -80px;
    }

    &:nth-child(1) div {
      transform: rotate(-30deg) translateY(80px);
    }

    &:nth-child(2) div {
      transform: rotate(-15deg);
    }

    &:nth-child(3) { // Handwriting hand
      z-index: 4;

      div {
        width: 310px;
        height: 310px;
        z-index: 4;
        transform: translateY(-80px);
        // overflow: hidden;
        background-color: unset;

        img {
          max-width: unset;
          width: 548px;
          margin-top: -3px;
          margin-left: -44px;
        }
      }
    }

    &:nth-child(4) div {
      transform: rotate(15deg);
    }

    &:nth-child(5) {
      z-index: -1;

      div {
        position: relative;
        transform: rotate(30deg) translateY(80px);
      }
    }
  }

  // CTA
  &__cta {
    text-align: center;

    p {
      @include margin-bottom(map-get($spacers, 5));
      @include font-size(map-get($proposal-page, 'font-size-lg'));
      font-weight: $font-weight-light;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-sm')) {
    &__deck {
      @include margin-top(map-get($spacers, 4) * 6);
      @include margin-bottom(map-get($spacers, 4) * 8);
    }

    &__card {
      flex: 0 0 190px;

      &:nth-child(3) { // Handwriting hand
        div {
          width: 190px;
          height: 190px;
          transform: translateY(-40px);

          img {
            width: 339px;
            margin-top: -2px;
            margin-left: -31px;
          }
        }
      }
    }
  }

  // ——————————————————————————————
  // XXS
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-xs')) {
    &__deck {
      @include margin-top(map-get($spacers, 4) * 10);
    }
  }

  // ——————————————————————————————
  // XS
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-xs')) and (max-width: map-get($proposal-page, 'viewport-sm')) {

  }

  // ——————————————————————————————
  // SM
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-sm')) and (max-width: map-get($proposal-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // MD
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-md')) and (max-width: map-get($proposal-page, 'viewport-lg')) {
  }
}
</style>
